import navigateToNextOnboardingPageAction from "@actions/navigateToNextOnboardingPageAction"
import isUserSignedInLoader from "@loaders/isUserSignedInLoader"
import skipOnboardingLoader from "@loaders/skipOnboardingLoader"
import EmailPage from "@pages/signUp/EmailPage"
import PasswordPage from "@pages/signUp/PasswordPage"
import { Navigate, Outlet } from "react-router-dom"
import ActivityLevel from "./ActivityLevel"
import AdditionalGoals from "./AdditionalGoals"
import Age from "./Age"
import AiFeature from "./AiFeature"
import CalorieCountingExperience from "./CalorieCountingExperience"
import CalorieCountingPositive from "./CalorieCountingPositive"
import ChallengesOvercome from "./ChallengesOvercome"
import ChooseGoal from "./ChooseGoal"
import Gender from "./Gender"
import GoalReason from "./GoalReason"
import GoalWeight from "./GoalWeight"
import Height from "./Height"
import HowCountedCalories from "./HowCountedCalories"
import HowFeeling from "./HowFeeling"
import KeyToSuccess from "./KeyToSuccess"
import LookForwardTo from "./LookForwardTo"
import Motivational1 from "./Motivational1"
import Motivational2 from "./Motivational2"
import NutritionGoal from "./NutritionGoal"
import { ONBOARDING_STEPS } from "./onboardingSteps"
import PastChallenges from "./PastChallenges"
import PastChanges from "./PastChanges"
import ProgressPlan from "./ProgressPlan"
import RestrictiveDiets from "./RestrictiveDiets"
import SocialProof from "./SocialProof"
import SpeedGoal from "./SpeedGoal"
import StayOnTrack from "./StayOnTrack"
import SustainableApproach from "./SustainableApproach"
import ValueProp from "./ValueProp"
import WaterIntake from "./WaterIntake"
import Weight from "./Weight"
import WeightGainCauses from "./WeightGainCauses"
import WeightLossAttempts from "./WeightLossAttempts"
import WellnessSnapshot from "./WellnessSnapshot"
import WhatsDifferent from "./WhatsDifferent"

const STEP_COMPONENTS: Record<string, React.ComponentType> = {
  activityLevel: ActivityLevel,
  additionalGoals: AdditionalGoals,
  age: Age,
  aiFeature: AiFeature,
  calorieCountingExperience: CalorieCountingExperience,
  calorieCountingPositive: CalorieCountingPositive,
  challengesOvercome: ChallengesOvercome,
  email: EmailPage,
  chooseGoal: Gender,
  goalReason: GoalReason,
  goalWeight: GoalWeight,
  height: Height,
  howCountedCalories: HowCountedCalories,
  howFeeling: HowFeeling,
  keyToSuccess: KeyToSuccess,
  mainGoal: ChooseGoal,
  motivational1: Motivational1,
  motivational2: Motivational2,
  nutritionGoal: NutritionGoal,
  password: PasswordPage,
  pastChallenges: PastChallenges,
  pastChanges: PastChanges,
  lookForwardTo: LookForwardTo,
  progressPlan: ProgressPlan,
  restrictiveDiets: RestrictiveDiets,
  socialProof: SocialProof,
  speedGoal: SpeedGoal,
  stayOnTrack: StayOnTrack,
  sustainableApproach: SustainableApproach,
  valueProp: ValueProp,
  waterIntake: WaterIntake,
  weight: Weight,
  weightGainCauses: WeightGainCauses,
  weightLossAttempts: WeightLossAttempts,
  wellnessSnapshot: WellnessSnapshot,
  whatsDifferent: WhatsDifferent,
}

const STEPS_WITHOUT_ACTION = ["email", "password"]
const AUTH_STEPS = ["email", "password"]

export function createOnboardingRoutes() {
  const childRoutes = ONBOARDING_STEPS.map((step) => {
    const Component = STEP_COMPONENTS[step]
    const useAction = !STEPS_WITHOUT_ACTION.includes(step)
    const useAuthLoader = AUTH_STEPS.includes(step)

    return {
      path: step,
      element: <Component />,
      ...(useAction && { action: navigateToNextOnboardingPageAction }),
      ...(useAuthLoader && { loader: isUserSignedInLoader }),
    }
  })

  return [
    {
      path: "/onboarding",
      element: <Outlet />,
      children: [
        {
          index: true,
          loader: skipOnboardingLoader,
          element: (
            <Navigate to={`chooseGoal${window.location.search}`} replace />
          ),
        },
        ...childRoutes,
      ],
    },
  ]
}
